export default "__VITE_ASSET__NOh_Lu7q__"